import fetch from "@/fetch";

// 获取捐赠征集列表
export const getCollectList = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/donorshowquery/querycollect",
    data: params,
  });
};

// 获取征集富文本详情
export const getCollectDetail = (params) => {
    return fetch({
      method: "post",
      url: "/common/h5/donorshowquery/getcollectdetail",
      data: params,
    });
  };
  
